module.exports = "<ul class=\"scFileTree\"><li><sc-file-tree-node ng-repeat=\"node in files.data\" filter=\"filter\" node=\"node\" path=\"getPath(node, '')\"></sc-file-tree-node></li></ul>"


//////////////////
// WEBPACK FOOTER
// ./src/view/filetree/files-tree.component.html
// module id = 510
// module chunks = 0